import React, { Component } from 'react';
import styled from 'styled-components';
import sectionBorderRadius from './sectionBorderRadius';

const YOUTUBE_DOMAIN = 'youtube.com';
const YOUTUBE_WWW_DOMAIN = 'www.youtube.com';
const YOUTUBE_SHORT_DOMAIN = 'youtu.be';
const YOUTUBE_WWW_SHORT_DOMAIN = 'www.youtu.be';
const VIMEO_DOMAIN = 'vimeo.com';
const VIMEO_WWW_DOMAIN = 'www.vimeo.com';

const queryParams = src =>
  src
    .substr(1)
    .split('&')
    .reduce((previous, current) => {
      const keyValue = current.split('=');
      previous[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      return previous;
    }, {});

const queryString = query =>
  Object.keys(query)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key].toString())}`)
    .join('&');

const VideoFrame = styled.iframe`
  border: 0;
  width: 100%;
  border-radius: inherit;
`;

const Wrapper = styled.div`
  color: ${props => props.theme.botCardMessageTextColor};
  background-color: ${props => props.theme.botCardMessageBackgroundColor};

  ${sectionBorderRadius};
`;

const YouTube = ({ embedId }) => (
  <VideoFrame
    src={`https://${YOUTUBE_DOMAIN}/embed/${embedId}?${queryString({ modestbranding: '1' })}`}
  />
);

const Vimeo = ({ embedId }) => (
  <VideoFrame
    src={`https://player.${VIMEO_DOMAIN}/video/${embedId}?${queryString({
      title: '0',
      byline: '0',
      portrait: '0',
      badge: '0'
    })}`}
  />
);

class Video extends Component {
  render() {
    const { src, isStart, isEnd } = this.props;

    const url = document.createElement('a');
    url.href = src;
    const urlQueryParams = queryParams(url.search);
    const pathSegments = url.pathname.substr(1).split('/');

    let videoComponent;

    switch (url.hostname) {
      case YOUTUBE_DOMAIN:
      case YOUTUBE_SHORT_DOMAIN:
      case YOUTUBE_WWW_DOMAIN:
      case YOUTUBE_WWW_SHORT_DOMAIN:
        videoComponent = (
          <YouTube
            embedId={
              url.hostname === YOUTUBE_DOMAIN || url.hostname === YOUTUBE_WWW_DOMAIN
                ? urlQueryParams.v
                : pathSegments[pathSegments.length - 1]
            }
            autoPlay={false}
            loop={false}
          />
        );
        break;

      case VIMEO_WWW_DOMAIN:
      case VIMEO_DOMAIN:
        videoComponent = <Vimeo embedId={pathSegments[pathSegments.length - 1]} />;
        break;

      default:
        videoComponent = <video controls src={url} />;
    }

    return (
      <Wrapper isStart={isStart} isEnd={isEnd} data-test-type="botVideo">
        {videoComponent}
      </Wrapper>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Video.js